"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvelopeAddressingProductOptionValue = exports.calculateDerivedProductOptions = exports.isProjectEmpty = exports.getProjectPrice = exports.getNumPrintablesInProject = exports.isDehydratedProject = exports.dehydratedProjectRuleSet = exports.isProject = exports.PROJECT_STATUS_IN_CART = exports.PROJECT_STATUS_FAILED_TRANSLATION = exports.PROJECT_STATUS_TRANSLATING = exports.PROJECT_STATUS_PRINTED = exports.PROJECT_STATUS_ADMIN_EDITING = exports.PROJECT_STATUS_IN_PROGRESS = exports.isProjectTemplate = exports.projectTemplateRuleSet = void 0;
exports.isArrayOfDehydratedProjects = isArrayOfDehydratedProjects;
const typeguard_1 = require("./../types/typeguard");
const Product_1 = require("./Product");
const PrintableGroup_1 = require("./printables/PrintableGroup");
const numbers_1 = require("../utils/numbers");
const UserPhotoLayer_1 = require("./layers/UserPhotoLayer");
const Address_1 = require("./Address");
exports.projectTemplateRuleSet = {
  collapsedInteriorPages: (0, typeguard_1.optional)(typeguard_1.isBool)
};
const isProjectTemplate = pt => (0, typeguard_1.isType)(pt, exports.projectTemplateRuleSet);
exports.isProjectTemplate = isProjectTemplate;
exports.PROJECT_STATUS_IN_PROGRESS = 'IN_PROGRESS';
exports.PROJECT_STATUS_ADMIN_EDITING = 'ADMIN_EDITING';
exports.PROJECT_STATUS_PRINTED = 'PRINTED';
exports.PROJECT_STATUS_TRANSLATING = 'TRANSLATING';
exports.PROJECT_STATUS_FAILED_TRANSLATION = 'FAILED_TRANSLATION';
exports.PROJECT_STATUS_IN_CART = 'IN_CART';
const projectRuleSet = {
  id: typeguard_1.isNonEmptyString,
  parentId: typeguard_1.isNonEmptyString,
  createdAt: typeguard_1.isISODateString,
  lastModifiedAt: typeguard_1.isISODateString,
  version: typeguard_1.isNumber,
  createdBy: typeguard_1.isNonEmptyString,
  lastModifiedBy: typeguard_1.isNonEmptyString,
  lastModifiedByAdmin: typeguard_1.isBool,
  schemaVersion: typeguard_1.isNumber,
  status: typeguard_1.isNonEmptyString,
  name: typeguard_1.isNonEmptyString,
  templateId: typeguard_1.isNonEmptyString,
  templateVersion: typeguard_1.isNumber,
  templateNameScheme: typeguard_1.isNonEmptyString,
  product: Product_1.isProduct,
  printableGroups: val => Array.isArray(val) && val.every(PrintableGroup_1.isPrintableGroup),
  emptyPageAck: typeguard_1.isBool,
  sourceProjectId: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  sourceCreatedBy: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  contactGroupId: (0, typeguard_1.optional)(typeguard_1.isString),
  versionStack: (0, typeguard_1.optional)(typeguard_1.isNumberArray),
  versionHistory: (0, typeguard_1.optional)(typeguard_1.isNumberArray),
  translatedFromV1: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  isDSProject: (0, typeguard_1.optional)(typeguard_1.isBool),
  selectedGalleryId: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  markedForDeletion: (0, typeguard_1.optional)(typeguard_1.isBool),
  addons: (0, typeguard_1.optional)(Array.isArray),
  envelopeReturnAddress: (0, typeguard_1.optional)(Address_1.isEnvelopeAddress)
};
const isProject = p => (0, typeguard_1.isType)(p, projectRuleSet);
exports.isProject = isProject;
exports.dehydratedProjectRuleSet = Object.assign(Object.assign({}, projectRuleSet), {
  printableGroups: val => Array.isArray(val) && val.every(PrintableGroup_1.isDehydratedPrintableGroup)
});
const isDehydratedProject = pg => (0, typeguard_1.isType)(pg, exports.dehydratedProjectRuleSet);
exports.isDehydratedProject = isDehydratedProject;
function isArrayOfDehydratedProjects(p) {
  return p.filter(p => (0, typeguard_1.isType)(p, exports.dehydratedProjectRuleSet) === true).length === p.length;
}
const getNumPrintablesInProject = p => p.printableGroups.reduce((numPrintables, printableGroup) => numPrintables + printableGroup.printables.length * printableGroup.qty, 0);
exports.getNumPrintablesInProject = getNumPrintablesInProject;
const getProjectPrice = (project, product) => {
  const projectOptions = project.product.options;
  const productBasePrice = product.price || 0;
  const productOptions = product.options;
  const price = Object.keys(projectOptions).reduce((totalPrice, optionTitle) => {
    const optionValue = projectOptions[optionTitle];
    const productOption = productOptions === null || productOptions === void 0 ? void 0 : productOptions.find(po => po.title === optionTitle);
    const productOptionValue = productOption === null || productOption === void 0 ? void 0 : productOption.values.find(pov => pov.title === optionValue);
    return totalPrice + ((productOptionValue === null || productOptionValue === void 0 ? void 0 : productOptionValue.price) || 0);
  }, productBasePrice);
  return (0, numbers_1.numberToUSD)(price);
};
exports.getProjectPrice = getProjectPrice;
const isProjectEmpty = p => {
  return p.printableGroups.every(printableGroup => printableGroup.printables.every(printable => printable.layers.filter(UserPhotoLayer_1.isUserPhotoLayer).every(layer => layer.userData == null)));
};
exports.isProjectEmpty = isProjectEmpty;
const calculateDerivedProductOptions = (options, project) => {
  const newOptions = Object.assign({}, options);
  if (newOptions.envelope_addressing) {
    newOptions['envelope_addressing'] = (0, exports.getEnvelopeAddressingProductOptionValue)(project);
  }
  return newOptions;
};
exports.calculateDerivedProductOptions = calculateDerivedProductOptions;
const getEnvelopeAddressingProductOptionValue = project => {
  if (project.envelopeReturnAddress && project.contactGroupId) {
    return 'both';
  } else if (project.envelopeReturnAddress) {
    return 'return';
  } else if (project.contactGroupId) {
    return 'both';
  } else {
    return 'none';
  }
};
exports.getEnvelopeAddressingProductOptionValue = getEnvelopeAddressingProductOptionValue;